<app-thankyou-success-head *ngIf="!config?.theme" [config]="config"></app-thankyou-success-head>

<div class="tipcard" [ngClass]="config?.theme">
  <img [loading]="lazy" *ngIf="!config?.theme" [attr.data-src]="'../assets/images/typbox.png'" alt="">
  <img [loading]="lazy" *ngIf="config?.theme?.match('v4')" [attr.data-src]="'../assets/images/saintemoji.png'" alt="">
  <div class="content">
    <div class="title">Support the platform</div>
    <div class="sub" *ngIf="!config?.theme">Adding a tip means being a key part of improving the services for the campaigns you support.</div>
    <div class="sub" *ngIf="config?.theme?.match('v4')">Leave us with a small tip today, so we can be better for campaigns you believe in.</div>
  </div>
  <app-payment-otd [InputConfig]="config"></app-payment-otd>
</div>
<div *ngIf="!config?.theme" class="viewlink" (click)="redirect()">
  View more Fundraisers
</div>